module.exports = __webpack_public_path__ + "img/calenderIcon.8840a818.svg";